import { useEffect, useState, useMemo } from "react";
import {
  Typography,
  Stack,
  Button,
  Box,
  TextField,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Grid,
} from "@mui/material";
import { NavigateBefore } from "@mui/icons-material";

import { ReactComponent as IconEdit } from "../../images/iconEdit.svg";
import { ReactComponent as IconUpload2 } from "../../images/iconUpload2.svg";

import api from "../../services/api";
import "./styles.css";
import {
  FieldDatePicker,
  FieldInputText,
  FieldTextarea,
  Label,
} from "../Fields";
import { formatDateISO8601 } from "../../utils/formatarData";
import ModalDialogs from "../ModalDialogs";
import dayjs from "dayjs";

const unitList = {
  "": "",
};

const url = `${process.env.REACT_APP_BASE_URL}`;

export default function DetalhesExames({
  open,
  setOpen,
  getExamesConsulta,
  id_vinculo,
  id_consulta_evolucao,
  detalhesExamesSelecionados,
}) {
  const [dataRealizacao, setDataRealizacao] = useState("");
  const [consideracoes, setConsideracoes] = useState("");
  const [anexo, setAnexo] = useState("");
  const [openCadastro, setOpenCadastro] = useState(false);
  const [openSucesso, setOpenSucesso] = useState(false);
  const [descricaoOperacao, setDescricaoOperacao] = useState(
    "Cadastrar resultado"
  );
  const [possuiResultadoExame, setPossuiResultadoExame] = useState(false);
  const [descricaoAcao, setDescricaoAcao] = useState("cadastrado");

  useEffect(() => {
    const possuiResultado =
      detalhesExamesSelecionados.resultadoExame.length !== 0;
    setPossuiResultadoExame(possuiResultado);
  }, [detalhesExamesSelecionados]);

  const handleClose = () => {
    setOpen(false);
    setOpenSucesso(false);
    setOpenCadastro(false);
    setDataRealizacao("");
    setConsideracoes("");
    setAnexo("");
  };

  console.log(detalhesExamesSelecionados);
  const handleModoEdicao = () => {
    setDescricaoOperacao("Editar resultado");
    setDescricaoAcao("editado");
    setConsideracoes(detalhesExamesSelecionados.resultadoExame.consideracao);
    setDataRealizacao(
      detalhesExamesSelecionados.resultadoExame.dataRealizacaoFormatacao
    );
    setOpenCadastro(true);
  };

  const handleSalvarArquivo = async (event) => {
    event.preventDefault();
    if (anexo.length !== 0 || consideracoes.length !== 0) {
      const dataForm = new FormData();
      dataForm.append("file", anexo);
      dataForm.append("data_realizacao", dataRealizacao);
      dataForm.append("consideracoes", consideracoes);
      dataForm.append("id_profissional", id_vinculo);

      const inputs = document.querySelectorAll(".custom-input");
      const resposta = [];

      inputs.forEach((input) => {
        resposta.push({
          idConsultaExame: input.id,
          idExame: input.dataset.idexame || "",
          resposta: input.value,
        });
      });

      dataForm.append("respostas", JSON.stringify(resposta));

      if (detalhesExamesSelecionados.tipo === "Laboratorial") {
        dataForm.append("id_consulta_evolucao", id_consulta_evolucao);
      } else {
        dataForm.append(
          "id_consulta_exame",
          detalhesExamesSelecionados.exams[0].idConsultaExame
        );
      }

      try {
        const response = await api.post(`/resultado-exame`, dataForm, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        setOpenSucesso(true);
        getExamesConsulta();
      } catch (error) {
        alert(error.response.data.error);
        console.error("Ocorreu um erro:", error.message);
      }
    } else {
    }
  };

  const abrirArquivo = (caminhoArquivo) => {
    const acessoArquivo = `${url}/${caminhoArquivo}`;
    window.open(acessoArquivo, "_blank");
  };

  const sortedExams = useMemo(() => {
    return detalhesExamesSelecionados?.exams
      ?.filter((exam) => exam.idExame <= 46) // Filtra os exames com idExame <= 46
      ?.sort((a, b) => a.idExame - b.idExame); // Ordena pelo idExame
  }, [detalhesExamesSelecionados?.exams]);

  const sortedExamsAll = useMemo(() => {
    return detalhesExamesSelecionados?.exams?.sort(
      (a, b) => a.idExame - b.idExame
    ); // Ordena pelo idExame
  }, [detalhesExamesSelecionados?.exams]);

  return (
    <>
      <Dialog open={open} id="modalDetalhesExames">
        <DialogTitle id="alert-dialog-title">
          <Button
            variant="outlined"
            sx={{ padding: "1px 5px", border: "none", textTransform: "none" }}
            onClick={() => handleClose()}
          >
            <NavigateBefore /> Voltar
          </Button>
        </DialogTitle>
        <DialogContent sx={{ height: "100%", maxWidth: "700px" }}>
          <DialogContentText id="alert-dialog-description">
            <Stack>
              <Typography component="h3" mb="20px" className="title">
                Resumo
              </Typography>
              <Stack direction="column" gap="16px">
                <Stack className="gridResume">
                  <Typography className="text bold">
                    Data solicitação
                  </Typography>
                  <Typography className="text">
                    {detalhesExamesSelecionados.dataCadastro}
                  </Typography>
                </Stack>
                <Stack className="gridResume">
                  <Typography className="text bold">Solicitante</Typography>
                  <Typography className="text">
                    {detalhesExamesSelecionados.detalhesCadastradoPor}
                  </Typography>
                </Stack>
                <Stack className="gridResume">
                  <Typography className="text bold">Exame</Typography>
                  <Typography className="text">
                    {detalhesExamesSelecionados.tipo}
                  </Typography>
                </Stack>
                <Stack className="gridResume">
                  <Typography className="text bold">Observações</Typography>
                  <Typography className="text">
                    <Typography>
                      {detalhesExamesSelecionados.observacao}
                    </Typography>
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
            <Divider sx={{ margin: "32px 0px" }} />

            <Stack className="sectionExame">
              <Stack className="header">
                <Typography className="title">Exames</Typography>
                {possuiResultadoExame ? (
                  <Button
                    onClick={() => handleModoEdicao()}
                    sx={{
                      width: "max-content",
                      background: "#fff !important",
                    }}
                  >
                    <IconEdit width="24px" />
                  </Button>
                ) : (
                  <Button
                    variant="contained"
                    onClick={() => setOpenCadastro(true)}
                  >
                    <IconUpload2 width="24px" /> {descricaoOperacao}
                  </Button>
                )}
              </Stack>

              {possuiResultadoExame && (
                <Stack direction="column" gap="16px" mb="24px">
                  <Stack className="gridResume">
                    <Typography className="text bold">Realizado em</Typography>
                    <Typography className="text">
                      {detalhesExamesSelecionados.resultadoExame.dataRealizacao}
                    </Typography>
                  </Stack>
                  <Stack className="gridResume">
                    <Typography className="text bold">
                      Cadastrado por
                    </Typography>
                    <Typography className="text">
                      {detalhesExamesSelecionados.resultadoExame.cadastradoPor}
                    </Typography>
                  </Stack>
                  <Stack className="gridResume">
                    <Typography className="text bold">Considerações</Typography>
                    <Typography className="text">
                      {detalhesExamesSelecionados.resultadoExame.consideracao}
                    </Typography>
                  </Stack>
                  <Stack className="gridResume">
                    <Typography className="text bold">Anexo</Typography>
                    <Typography className="text">
                      {detalhesExamesSelecionados.resultadoExame.nomeArquivo}
                      {" - "}
                      {detalhesExamesSelecionados.resultadoExame.tamanhoArquivo}
                      <Button
                        variant="outlined"
                        sx={{
                          textTransform: "none",
                          marginLeft: "24px",
                        }}
                        onClick={() =>
                          abrirArquivo(
                            detalhesExamesSelecionados.resultadoExame
                              .caminhoArquivo
                          )
                        }
                      >
                        Baixar
                      </Button>
                    </Typography>
                  </Stack>
                </Stack>
              )}

              <TableContainer component="div" className="tableContainer">
                <Table aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell
                        className="text tableItem"
                        sx={{ color: "#1E729F !important" }}
                      >
                        Item
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody className="tableBody">
                    {sortedExamsAll.map((row, index) => (
                      <TableRow key={index}>
                        <TableCell
                          component="td"
                          scope="row"
                          className="text tableItem"
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                            gap: 2,
                          }}
                        >
                          {row.nome}
                          <Box className="custom-input-container" gap={1}>
                            <Typography
                              variant="body1"
                              className="text"
                              component={"span"}
                              id={row.idConsultaExame}
                              data-idExame={row.idExame}
                            >
                              {row.resultado?.resposta ?? ""}
                            </Typography>
                            <Typography variant="caption" component={"span"}>
                              {/* colocar a unidade aqui */}
                            </Typography>
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Stack>
          </DialogContentText>
        </DialogContent>
      </Dialog>

      <ModalDialogs
        open={openCadastro}
        onClose={handleClose}
        title={descricaoOperacao}
        maxWidth="800px"
        body={
          <Box
            id="modalDetalhesExames-ModalCadastro"
            sx={{ width: { xs: "100%", md: "800px" } }}
            textAlign="start"
          >
            <Box
              component="form"
              autoComplete="off"
              onSubmit={handleSalvarArquivo}
              sx={{
                overflow: "auto",
                height: "80vh",
              }}
            >
              <Box sx={{ padding: "8px 16px", gap: "16px", display: "grid" }}>
                <FieldDatePicker
                  label="Realizado em"
                  value={dataRealizacao}
                  maxDate={dayjs(new Date())}
                  setValue={(value) =>
                    setDataRealizacao(formatDateISO8601(value))
                  }
                  labelDatePicker={"dia/mê/ano"}
                  required
                />

                <FieldTextarea
                  label="Considerações"
                  value={consideracoes}
                  setValue={(value) => setConsideracoes(value)}
                  required
                />

                <Stack id="modalDetalhesExames">
                  <Stack
                    className="sectionExame"
                    sx={{
                      width: "100%",
                    }}
                  >
                    <TableContainer component="div" className="tableContainer">
                      <Table aria-label="simple table">
                        <TableHead>
                          <TableRow>
                            <TableCell
                              className="text tableItem"
                              sx={{ color: "#1E729F !important" }}
                            >
                              Exames
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody className="tableBody">
                          {sortedExams.map((row, index) => (
                            <TableRow key={index}>
                              <TableCell
                                component="td"
                                scope="row"
                                className="text tableItem"
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  width: "100%",
                                  gap: 2,
                                }}
                              >
                                {row.nome}{" "}
                                <Box className="custom-input-container">
                                  <input
                                    id={row.idConsultaExame}
                                    data-idExame={row.idExame}
                                    name={row.nome}
                                    defaultValue={row.resultado?.resposta ?? ""}
                                    type="text"
                                    className="custom-input"
                                  />
                                  <Typography
                                    variant="span"
                                    component={"span"}
                                    className="unit"
                                  >
                                    {/* colocar a unidade aqui */}
                                  </Typography>
                                </Box>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Stack>
                </Stack>

                <Stack>
                  <Label
                    htmlFor="selectedFile"
                    className="labelFile"
                    title={"Anexo"}
                    required
                  />

                  <TextField
                    type="file"
                    id="selectedFile"
                    sx={{ display: "none" }}
                    inputProps={{
                      accept:
                        "image/png, image/jpeg, image/jpg, application/pdf",
                    }}
                    onChange={(e) => setAnexo(e.target.files[0])}
                  />
                  <Button
                    type="button"
                    className="buttonFile"
                    onClick={() =>
                      document.getElementById("selectedFile").click()
                    }
                  >
                    <IconUpload2 width="24px" />
                    {anexo.name ||
                      detalhesExamesSelecionados?.resultadoExame?.nomeArquivo ||
                      "Selecione um arquivo"}
                  </Button>
                </Stack>
              </Box>

              <Box className="footerModal">
                <Button
                  sx={{
                    textTransform: "none",
                    mr: 1,
                    color: "##1e729f",
                    border: "1px solid #1e729f",
                    fontSize: "1.1rem",
                  }}
                  variant="outlined"
                  onClick={() => handleClose()}
                >
                  Cancelar
                </Button>
                <Button
                  sx={{
                    textTransform: "none",
                    color: "white",
                    background: "##1e729f",
                    fontSize: "1.1rem",
                  }}
                  variant="contained"
                  type="submit"
                >
                  {descricaoOperacao}
                </Button>
              </Box>
            </Box>
          </Box>
        }
      />

      <ModalDialogs
        open={openSucesso}
        onClose={handleClose}
        modalType="success"
        title="Sucesso"
        body={
          <Box sx={{ width: { xs: "100%", sm: "400px" } }}>
            Resultado {descricaoAcao}
            <br />
            <Box fontWeight={400} fontSize="16px">
              Resultado de exame {descricaoAcao} com sucesso
            </Box>
          </Box>
        }
      />
    </>
  );
}
